import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { downloadLinks } from 'src/config';
import { SvgImage } from 'src/helpers';
import Analytics from 'src/helpers/analytics';
import { ApplicationDownloadButtonsIcon, ApplicationDownloadButtonsWrapper } from 'src/styles/signup/signupSteps';

const ApplicationDownloadButtons = () => {
  const {
    allContentfulFooter: { edges },
  } = useStaticQuery(graphql`
    query ApplicationDownloadButtonsQuery {
      allContentfulFooter {
        edges {
          node {
            googlePlayIcon {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
            appStoreIcon {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
          }
        }
      }
    }
  `);

  const { googlePlayIcon, appStoreIcon } = edges[0].node;

  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
  };

  return (
    <ApplicationDownloadButtonsWrapper>
      <a onClick={() => onAppClick('google_play')} href={downloadLinks.googlePlay} target="_blank" rel="noreferrer">
        <ApplicationDownloadButtonsIcon>
          <SvgImage {...googlePlayIcon} />
        </ApplicationDownloadButtonsIcon>
      </a>
      <a onClick={() => onAppClick('app_store')} href={downloadLinks.appStore} target="_blank" rel="noreferrer">
        <ApplicationDownloadButtonsIcon>
          <SvgImage {...appStoreIcon} />
        </ApplicationDownloadButtonsIcon>
      </a>
    </ApplicationDownloadButtonsWrapper>
  );
};
export default ApplicationDownloadButtons;
